// src/engine/tcoFleetEngine.js

export function calcKmPeriodo(duracionMeses, kmAnuales) {
  return duracionMeses * (kmAnuales / 12);
}

export function calcCombustibleMes(consumoL100, kmPeriodo, precioLitro, duracionMeses) {
  // Excel: = Consumo * KmPeriodo/100 * PrecioLitro / Duración
  return (consumoL100 * (kmPeriodo / 100) * precioLitro) / duracionMeses;
}

export function calcMantenimientoMes(mantenimientoAnual) {
  // Excel: mantenimiento / 12
  return (mantenimientoAnual || 0) / 12;
}

export function calcSeguroMes(seguroAnual) {
  // Excel: seguro / 12
  return (seguroAnual || 0) / 12;
}

export function calcRuedasMes(precioRueda, duracionMeses) {
  // Excel: = 4 * precioRueda / duración
  return (4 * (precioRueda || 0)) / duracionMeses;
}

export function calcCostesUsoMes({ mantenimientoAnual, precioRueda, seguroAnual }, duracionMeses) {
  return (
    calcMantenimientoMes(mantenimientoAnual) +
    calcRuedasMes(precioRueda, duracionMeses) +
    calcSeguroMes(seguroAnual)
  );
}

/**
 * Compra (TCO):
 * TCO €/mes = cuotaFinanciacionMes + combustibleMes + (mantenimientoMes + ruedasMes + seguroMes)
 *
 * Nota: en tu Excel la cuota mensual está metida como INPUT por vehículo. Aquí igual (manual).
 */
export function calcTCOCompra({
  duracionMeses,
  kmAnuales,
  precioLitro,
  vehiculo, // { consumoL100, cuotaMensual, mantenimientoAnual, precioRueda, seguroAnual }
}) {
  const kmPeriodo = calcKmPeriodo(duracionMeses, kmAnuales);

  const cuotaMensual = Number(vehiculo.cuotaMensual || 0);
  const combustibleMes = calcCombustibleMes(
    Number(vehiculo.consumoL100 || 0),
    kmPeriodo,
    Number(precioLitro || 0),
    duracionMeses
  );

  const mantenimientoMes = calcMantenimientoMes(Number(vehiculo.mantenimientoAnual || 0));
  const ruedasMes = calcRuedasMes(Number(vehiculo.precioRueda || 0), duracionMeses);
  const seguroMes = calcSeguroMes(Number(vehiculo.seguroAnual || 0));

  const usoMes = mantenimientoMes + ruedasMes + seguroMes;
  const tcoMes = cuotaMensual + combustibleMes + usoMes;

  return {
    kmPeriodo,
    cuotaMensual,
    combustibleMes,
    mantenimientoMes,
    ruedasMes,
    seguroMes,
    usoMes,
    tcoMes,
  };
}

/**
 * Renting (TCU):
 * TCU €/mes = cuotaSinIVA + combustibleMes
 */
export function calcTCURenting({
  duracionMeses,
  kmAnuales,
  precioLitro,
  vehiculo, // { consumoL100, cuotaSinIVA }
}) {
  const kmPeriodo = calcKmPeriodo(duracionMeses, kmAnuales);

  const cuotaSinIVA = Number(vehiculo.cuotaSinIVA || 0);
  const ivaMes = cuotaSinIVA * 0.21;
  const cuotaConIVA = cuotaSinIVA + ivaMes;

  const combustibleMes = calcCombustibleMes(
    Number(vehiculo.consumoL100 || 0),
    kmPeriodo,
    Number(precioLitro || 0),
    duracionMeses
  );

  const tcuMes = cuotaSinIVA + combustibleMes;

  return { kmPeriodo, cuotaConIVA, cuotaSinIVA, ivaMes, combustibleMes, tcuMes };
}


